const API_KEY = process.env.REACT_APP_GOOGLE_TIMEZONE_API_KEY;

const getTimezone = (location, timestamp) => fetch(`https://maps.googleapis.com/maps/api/timezone/json?location=${location.join(',')}&timestamp=${timestamp}&key=${API_KEY}`, {
    method: 'get',
});

export default getTimezone;
